module.exports = __webpack_public_path__ + "static/media/kendra-photo-1.5e297fd7.PNG";